// ABOUTME: Utility functions for formatting SharePoint file data
// ABOUTME: Pure functions extracted from components for reusability

import type { IntlShape } from 'react-intl';

/**
 * Format file size in bytes to human-readable format
 */
export const formatFileSize = (bytes?: number): string => {
    if (!bytes) return '';
    const sizes = ['B', 'KB', 'MB', 'GB'] as const;
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Math.round((bytes / 1024 ** i) * 100) / 100} ${sizes[i]}`;
};

/**
 * Format date string to localized format
 */
export const formatDate = (date?: string, locale = 'en-US'): string => {
    if (!date) return '';
    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(date));
};

/**
 * Get file type label based on file name
 */
export const getFileTypeLabel = (fileName: string, intl: IntlShape): string => {
    const lowerName = fileName.toLowerCase();

    if (lowerName.endsWith('.pdf')) {
        return intl.formatMessage({
            id: 'sharepoint.file-type.pdf-document',
            defaultMessage: 'Documento PDF',
        });
    }
    if (lowerName.endsWith('.csv')) {
        return intl.formatMessage({
            id: 'sharepoint.file-type.csv-document',
            defaultMessage: 'Documento CSV',
        });
    }
    if (lowerName.match(/\.(jpg|jpeg|png|gif)$/i)) {
        return intl.formatMessage({ id: 'sharepoint.file-type.image', defaultMessage: 'Immagine' });
    }
    if (lowerName.match(/\.(doc|docx)$/i)) {
        return intl.formatMessage({
            id: 'sharepoint.file-type.word-document',
            defaultMessage: 'Documento Word',
        });
    }
    if (lowerName.match(/\.(xls|xlsx)$/i)) {
        return intl.formatMessage({
            id: 'sharepoint.file-type.excel-document',
            defaultMessage: 'Documento Excel',
        });
    }
    if (lowerName.match(/\.(ppt|pptx)$/i)) {
        return intl.formatMessage({
            id: 'sharepoint.file-type.powerpoint-document',
            defaultMessage: 'Documento PowerPoint',
        });
    }

    return intl.formatMessage({ id: 'sharepoint.file-type.document', defaultMessage: 'Documento' });
};
